import { Stack } from "@altimateai/lego";
import { Typography } from "@altimateai/lego";
import { IconMailCheck } from "@tabler/icons-react";
import { Navigate, useLocation } from "react-router-dom";
import { BaseContainer } from "./components/base";

interface VerifiedLocationState {
  email?: string;
}

export function Verified() {
  const location = useLocation();
  const state = location.state as VerifiedLocationState | null;
  const email = state?.email;

  if (!email) return <Navigate to="/login" />;

  return (
    <BaseContainer>
      <Stack direction="column" align="center" gap="xl">
        <IconMailCheck size={64} />
        <Typography variant="page-heading">
          Thanks for signing up
        </Typography>
        <Typography className="al-text-primary">
          An email has been sent to <strong>{email}</strong> with instructions to
          activate the account. Please check your <strong>spam folder</strong> if
          needed.
        </Typography>
        <Typography className="al-text-yellow-600">
          You cannot sign in without activating the account from your email.
        </Typography>
      </Stack>
    </BaseContainer>
  );
}
